import create from 'zustand';
import { Notification } from '@modules/notifications/types';
import { NotificationsStore } from '../types/NotificationsStore';
import { AUTOCLOSE_NOTIFICATION_TIMEOUT } from '../constants';
import { addNotification, removeNotification } from '../services/notifications';

export const useNotificationsStore = create<NotificationsStore>((set, get) => ({
  notifications: [],
  addNotification: (notification: Notification) =>
    set(() => {
      notification.id = notification.id ?? new Date().getTime();

      const notifications: Notification[] = addNotification(get().notifications, notification);

      if (notification.autoClose) {
        setTimeout(() => {
          if (!notification.id) {
            throw new Error('Notification ID must be defined.');
          }

          get().removeNotification(notification.id);
        }, AUTOCLOSE_NOTIFICATION_TIMEOUT);
      }

      return {
        notifications,
      };
    }),
  removeNotification: (id: number) =>
    set(() => {
      return {
        notifications: removeNotification(get().notifications, id),
      };
    }),
}));
